export default "__VITE_ASSET__DYaqYtUn__"